import { useEffect, useState } from "react";
import "./Navbar.css";

import {
  AppBar,
  Box,
  Container,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";

import { Link, useLocation } from "react-router-dom";

import { FaBars, FaPhoneAlt, FaTimes, FaWhatsapp } from "react-icons/fa";

import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { useMediaQuery, useTheme } from "@mui/material";
import navbarbgm from "../../assets/images/New/navbar_bg_n.png";
import navbarbg from "../../assets/images/New/navbar_bg_n2.png";
import navbar_bg_n_d from "../../assets/images/navbar_bg_n_d.png";
import logo from "../../assets/logos/logo-bc.png";
const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Pricing", path: "/pricing" },
  { name: "Contact", path: "/contact" },
];

function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [scrolled, setScrolled] = useState(false);

  const location = useLocation();

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <AppBar
        position="relative"
        elevation={0}
        className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}
        sx={{
          backgroundImage: {
            xs: ` url(${navbarbgm})`,
            md: ` url(${navbarbg})`,
          },
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",

          backdropFilter: "blur(20px)",

          // borderBottom: "1px solid rgba(0,87,255,.08)",

          // boxShadow: scrolled ? "0 10px 35px rgba(0,87,255,.08)" : "none",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar className="navbar-toolbar">
            {/* LOGO */}

            <Link to="/" className="logo-wrapper">
              <img src={logo} alt="Comet Cleaners" className="navbar-logo" />
            </Link>

            {/* DESKTOP MENU */}

            <Box className="desktop-menu">
              {navLinks.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  className={`nav-link ${
                    location.pathname === item.path ? "active-link" : ""
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </Box>

            {/* RIGHT ACTIONS */}

            <Box className="desktop-actions">
              <a href="tel:+19054283542" className="icon-btn">
                <FaPhoneAlt />
              </a>

              <a
                href="https://wa.me/+19054283542"
                target="_blank"
                rel="noreferrer"
                className="whatsapp-btn"
              >
                <FaWhatsapp />
                WhatsApp
              </a>
            </Box>

            {/* MOBILE BUTTON */}

            <IconButton
              className="mobile-menu-btn"
              onClick={toggleDrawer}
              sx={{
                width: 42,
                height: 42,
                display: {
                  xs: "flex",
                  lg: "none",
                },

                background: "#0057FF",

                color: "#fff",

                border: "2px solid #ffffff",

                boxShadow: "0 8px 20px rgba(0,87,255,.25)",

                "&:hover": {
                  background: "#fff",
                  color: "#0057FF",
                  border: "2px solid #0057FF",
                },
              }}
            >
              {mobileOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* MOBILE DRAWER */}

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={toggleDrawer}
        PaperProps={{
          sx: {
            width: "90%",
            maxWidth: 450,

            backgroundImage: `url(${navbar_bg_n_d})`,

            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",

            backdropFilter: "blur(20px)",

            borderTopLeftRadius: "34px",
            borderBottomLeftRadius: "34px",

            border: "1px solid rgba(255,255,255,.7)",

            boxShadow: "-20px 0 60px rgba(0,87,255,.12)",

            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            height: "auto",
            display: "flex",
            flexDirection: "column",
            p: 3,
            position: "relative",

            "&::before": {
              content: '""',
              position: "absolute",
              left: 0,
              top: 30,
              bottom: 30,
              width: "4px",
              borderRadius: "20px",
              background: "linear-gradient(180deg,#0057FF,#1DB6FF)",
            },
            backgroundImage: `url(${navbar_bg_n_d})`,

            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          {/* TOP */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 5,
            }}
          >
            <img
              src={logo}
              alt="Comet Cleaners"
              style={{
                width: "170px",
                objectFit: "contain",
              }}
            />

            <IconButton
              onClick={toggleDrawer}
              sx={{
                width: 44,
                height: 44,

                background: "rgba(255,255,255,.85)",

                backdropFilter: "blur(10px)",

                border: "1px solid rgba(255,255,255,.8)",

                color: "#0057FF",

                "&:hover": {
                  background: "#0057FF",
                  color: "#fff",
                },
              }}
            >
              <FaTimes />
            </IconButton>
          </Box>
          {/* CONTACT CARD */}
          <Box
            sx={{
              p: 2.5,
              mb: 3,

              borderRadius: "22px",

              background: "rgba(255,255,255,.78)",

              backdropFilter: "blur(12px)",

              border: "1px solid rgba(255,255,255,.9)",

              boxShadow: "0 10px 30px rgba(0,87,255,.08)",
            }}
          >
            <Typography
              sx={{
                fontWeight: 800,
                color: "#0057FF",
                fontSize: "15px",
                mb: 1,
              }}
            >
              Premium Garment Care
            </Typography>

            <Typography
              sx={{
                color: "#64748B",
                fontSize: "13px",
                lineHeight: 1.8,
              }}
            >
              15 Westney Rd N, Unit 4A, Ajax, ON L1T 1P5
            </Typography>
          </Box>
          {/* NAVIGATION */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
            }}
          >
            {navLinks.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={toggleDrawer}
                style={{
                  textDecoration: "none",
                }}
              >
                <Box
                  sx={{
                    height: 60,

                    px: 3,

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",

                    borderRadius: "18px",

                    background:
                      location.pathname === item.path
                        ? "linear-gradient(135deg,#0057FF,#1DB6FF)"
                        : "rgba(255,255,255,.75)",

                    color: location.pathname === item.path ? "#fff" : "#07122F",

                    fontWeight: 700,

                    border: "1px solid rgba(255,255,255,.8)",

                    backdropFilter: "blur(10px)",

                    transition: ".3s",

                    "&:hover": {
                      transform: "translateX(5px)",
                    },
                  }}
                >
                  {item.name}

                  <Typography
                    sx={{
                      fontWeight: 700,
                    }}
                  >
                    <ArrowForwardIosRoundedIcon
                      sx={{
                        fontSize: 15,

                        color:
                          location.pathname === item.path ? "#fff" : "#0057FF",

                        transition: ".3s",
                      }}
                    />
                  </Typography>
                </Box>
              </Link>
            ))}
          </Box>{" "}
          {/* BOTTOM */}
          <Box
            sx={{
              mt: "auto",
              pt: 5,

              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <a
              href="tel:+19054283542"
              style={{
                textDecoration: "none",
              }}
            >
              <Box
                sx={{
                  height: 58,

                  borderRadius: "18px",

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                  gap: 1.5,

                  background: "rgba(255,255,255,.85)",

                  border: "1px solid rgba(255,255,255,.8)",

                  backdropFilter: "blur(10px)",

                  color: "#07122F",

                  fontWeight: 700,

                  boxShadow: "0 8px 25px rgba(0,87,255,.06)",
                }}
              >
                <FaPhoneAlt />
                Call Now
              </Box>
            </a>

            <a
              href="https://wa.me/+19054283542"
              target="_blank"
              rel="noreferrer"
              style={{
                textDecoration: "none",
              }}
            >
              <Box
                sx={{
                  height: 60,

                  borderRadius: "18px",

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                  gap: 1.5,

                  background: "linear-gradient(135deg,#25D366,#19B85A)",

                  color: "#fff",

                  fontWeight: 800,

                  boxShadow: "0 15px 35px rgba(37,211,102,.25)",
                }}
              >
                <FaWhatsapp />
                WhatsApp Us
              </Box>
            </a>

            <Box
              sx={{
                mt: 1,
                mb: 3,

                textAlign: "center",

                color: "#64748B",

                fontSize: "12px",

                fontWeight: 600,
              }}
            >
              Trusted Premium Laundry Service
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}

export default Navbar;
